import type { Messages } from './types';

export const en: Messages = {
  helpMenu: 'Help',
  tutorial: 'Tutorial…',
  language: 'Language…',
  keyboardShortcuts: 'Keyboard Shortcuts…',
  languageTitle: 'Language',
  languageHint: 'Choose the language for the welcome screen, tutorial, and Help menu.',
  languageEnglish: 'English',
  languageUkrainian: 'Ukrainian',
  close: 'Close',
  next: 'Next',
  back: 'Back',
  done: 'Done',
  skip: 'Skip',
  welcomeTitle: 'Pixotah',
  welcomeText:
    'A layered photo editor that runs entirely in your browser. Files never leave your machine — every operation is computed by your graphics card.',
  welcomeNew: 'New Document',
  welcomeOpen: 'Open Image',
  welcomeDrop: 'Or just drop a file into the window.',
  welcomeTutorial: 'Take the tour',
  tutorialTitle: 'Welcome to Pixotah',
  tutorialSteps: [
    {
      title: 'Documents',
      body: 'Create a new document from File → New, or open an image / PDF. Everything stays on your device — nothing is uploaded.',
    },
    {
      title: 'Tools',
      body: 'The left toolbar holds Move, selection, Brush, Type (T), shapes, and more. Hold or right-click nested tools for the flyout. Options for the active tool appear in the top bar.',
    },
    {
      title: 'Layers',
      body: 'Build your image in the Layers panel on the right. Double-click a layer to open Layer Style. Use the fx badge and opacity / blend mode controls like in Photoshop.',
    },
    {
      title: 'Type',
      body: 'Select the Type tool (T), click the canvas, and type. Change font, size, color, bold, and italic in the options bar or Properties. Double-click text to edit again.',
    },
    {
      title: 'Panels',
      body: 'The icon strip beside the panels opens Brush, Character, Info, and more. Tabs switch Swatches / History and Layers / Channels / Paths. Press F7 for Layers, F9 for History.',
    },
    {
      title: 'Shortcuts',
      body: 'Open Help → Keyboard Shortcuts for the full list. Undo with Ctrl+Z, save as PSD with Ctrl+S, and hide panels with Tab.',
    },
  ],
};
